<main
  [style.zIndex]="index"
  style="position: fixed; top: 0; right: 0; bottom: 0"
  [hidden]="isComponentHidden"
>
  <kendo-drawer-container>
    <kendo-drawer
      style="height: 100vh"
      [width]="drawerWidth"
      #drawer
      [mode]="'overlay'"
      [position]="'end'"
      [expanded]="false"
      [autoCollapse]="false"
      [animation]="animationOptions"
      appClickOutsideDrawer
      (clickedOutside)="closeSideDrawer(null)"
    >
      <ng-template kendoDrawerTemplate>
        <app-expense-add
          (closeDrawer)="closeSideDrawer($event)"
          [isInDrawerMode]="true"
          [invoiceUid]="invoiceUid"
        ></app-expense-add>
      </ng-template>
    </kendo-drawer>
  </kendo-drawer-container>
</main>
